export default function Footer() {
  const footerLinks = [
    {
      title: "Company",
      links: [
        { label: "About Us", href: "/about" },
        { label: "Our Products", href: "/products" },
        { label: "Contact", href: "/contact" },
        { label: "Careers", href: "/contact" },
      ],
    },
    {
      title: "Legal",
      links: [
        { label: "Terms of Use", href: "/terms" },
        { label: "Privacy Policy", href: "/privacy" },
        { label: "Refund Policy", href: "/refund" },
      ],
    },
  ];

  return (
    <footer id="footer" className="w-full bg-[#0d0d0d] border-t border-white/[0.06]">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-6xl mx-auto py-16 md:py-20">

        {/* Top row */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 pb-10 md:pb-12 border-b border-white/[0.06]">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span
                className="text-base font-bold tracking-[0.16em] text-white uppercase"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                Trevionix
              </span>
              <span className="w-px h-4 bg-white/20" />
              <span
                className="text-[11px] tracking-[0.12em] text-[#6C7278] uppercase"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                LTD
              </span>
            </div>
            <p
              className="text-sm text-[#6C7278] max-w-[260px] leading-relaxed"
              style={{ fontFamily: "'Public Sans', sans-serif" }}
            >
              International House<br />
              12 Constance Street<br />
              London, E16 2DQ<br />
              United Kingdom
            </p>
            <a
              href="mailto:support@trevionics.com"
              className="mt-3 flex items-center gap-2 text-sm text-[#6C7278] hover:text-white transition-colors"
              style={{ fontFamily: "'Public Sans', sans-serif" }}
            >
              <i className="ri-mail-line text-[#B8422E] text-xs" />
              support@trevionics.com
            </a>
            <a
              href="tel:+447520658798"
              className="mt-1.5 flex items-center gap-2 text-sm text-[#6C7278] hover:text-white transition-colors"
              style={{ fontFamily: "'Public Sans', sans-serif" }}
            >
              <i className="ri-phone-line text-[#B8422E] text-xs" />
              +44 7520 658798
            </a>
          </div>
        </div>

        {/* Link columns */}
        <div className="mt-10 md:mt-12 grid grid-cols-2 md:grid-cols-2 gap-8 md:gap-12">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4
                className="text-[11px] uppercase tracking-[0.18em] text-[#6C7278] mb-5"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {group.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-white/50 hover:text-white transition-colors duration-200"
                      style={{ fontFamily: "'Public Sans', sans-serif" }}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-12 md:mt-16 pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p
            className="text-xs text-[#6C7278]"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            &copy; 2026 Trevionix LTD. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}